import { AUTH_RESOURCES } from '@anschuetz-elog/common';
import { RouteConfig } from 'vue-router';

const routes: RouteConfig[] = [
  {
    path: '/sounding-spots',
    component: () => import('#/components/LicenseGuard.vue'),
    props: { license: 'SOUNDING_SPOTS' },
    meta: { authorization: { action: 'read', subject: AUTH_RESOURCES.SOUNDING_SPOT } },
    children: [
      {
        path: '',
        name: 'sounding-spots',
        component: () => import('#/views/sounding-spots/SoundingSpots.vue'),
        props: true,
        meta: { authorization: { action: 'read', subject: AUTH_RESOURCES.SOUNDING_SPOT } },
      },
      {
        path: ':location',
        name: 'sounding-spots-location',
        component: () => import('#/views/sounding-spots/SoundingSpotsLocation.vue'),
        meta: { authorization: { action: 'read', subject: AUTH_RESOURCES.SOUNDING_SPOT } },
        props: true,
      },

      {
        path: ':location/create',
        name: 'sounding-spots-create',
        component: () => import('#/views/sounding-spots/SoundingSpotCreate.vue'),
        meta: { authorization: { action: 'create', subject: AUTH_RESOURCES.SOUNDING_SPOT } },
        props: true,
      },

      {
        path: ':location/edit/:soundingSpotId',
        name: 'sounding-spots-edit',
        component: () => import('#/views/sounding-spots/SoundingSpotEdit.vue'),
        meta: { authorization: { action: 'update', subject: AUTH_RESOURCES.SOUNDING_SPOT } },
        props: true,
      },
    ],
  },
];

export default routes;
